import React, { useEffect } from 'react'

import { useHistory, useLocation } from 'react-router-dom'
import { useParams, useQuery } from 'utils/hooks'
import { useEntity, useEntityFetchStatus } from 'redux/hooks/Entities'

import * as UserEvents from 'redux/api/internal/UserEvents'
import { Action } from 'types/GlobalUserEvents'
import { getContext } from 'utils/userEvents'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import ErrorPlaceholder from 'components_new/molecules/ErrorPlaceholder'

import EntityHeader from 'components_new/organisms/EntityHeader'
import EntityPreview from 'components_new/organisms/EntityPreview'
import EntitySettings from 'components_new/organisms/EntitySettings'

import PageLayout from 'components_new/templates/PageLayout'
import { useTranslation } from 'language/translator'

import TopbarActions from './topbar/Actions'
import getTopbarBreadcrumbs from './topbar/Breadcrumbs'

const Entity = () => {
  const { query, setQuery } = useQuery()
  const { search } = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { t, lang } = useTranslation()
  const entity = useEntity(id)
  const fetchStatus = useEntityFetchStatus()

  const searchParams = new URLSearchParams(search)

  useEffect(() => {
    if (id) {
      const context = getContext(searchParams)

      UserEvents.log({
        action: Action.ENTITY_OPENED,
        context: context,
        dashboard_id: null,
        dashboard_group_id: null
      })
    }
  }, [id])

  const edit = Boolean(query['edit'])

  const handleOnClick = () => {
    if (edit) {
      setQuery({ edit: null })
    } else {
      setQuery({ edit: 'true' })
    }
  }

  if ((fetchStatus === 'success' || fetchStatus === 'error') && !entity) {
    return (
      <PageLayout
        topbar={{
          breadcrumbs: getTopbarBreadcrumbs(t('entities', 'entities'))
        }}
        variant="static"
      >
        <ErrorPlaceholder
          code={404}
          body={t('entities', 'error_not_found_body')}
          actions={
            <Button
              onClick={() => history.push('/entities')}
              startIcon={<Icon name="ArrowBackOutlined" />}
              variant="text"
            >
              {t('entities', 'entities')}
            </Button>
          }
        />
      </PageLayout>
    )
  }

  return (
    <PageLayout
      content={{
        hero: <EntityHeader entity={entity} />
      }}
      rightSidebar={{
        content: <EntitySettings />,
        size: edit ? 'xlarge' : 'medium',
        // open sidebar on edit
        collapsed: edit ? false : undefined
      }}
      topbar={{
        actions: (
          <TopbarActions
            edit={edit}
            entity={entity}
            onToggleEdit={handleOnClick}
          />
        ),
        breadcrumbs: getTopbarBreadcrumbs(
          t('entities', 'entities'),
          entity?.title[lang]
        )
      }}
      variant="static"
    >
      <EntityPreview />
    </PageLayout>
  )
}

export default Entity
